export default function FallbackSrc() {
            return {
                link: function(scope, element, attrs) {
                    element.bind('error', function() {
                        if (attrs.src !== attrs.fallbackSrc) {
                            attrs.$set('src', attrs.fallbackSrc);
                        }
                    });
                },
            };
}



// WEBPACK FOOTER //
// ./src/app/directives/fallback-src-directive.js